import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import UninsuredPet from './UninsuredPet';
import { YoungPetModal } from './YoungPetModal';

import { resetValidationBreedMultibrand } from '../../actions';

const NoPolicyPets = ({
  currentPet,
  isYoungPetModalVisible = false,
  onGetQuote = () => { },
  onlyFigo = false,
}) => {
  const dispatch = useDispatch();
  useEffect(() => () => {
    dispatch(resetValidationBreedMultibrand());
  }, [dispatch]);

  const handleGetQuote = () => {
    onGetQuote({ petID: currentPet.PetId });
  };

  return (
    <>
      <UninsuredPet
        onGetQuote={handleGetQuote}
        petBreedName={currentPet?.Breed}
        petImage={currentPet?.ProfileUrl}
        petName={currentPet?.PetName}
        petType={currentPet?.Type}
        showLearnMore={onlyFigo}
      />

      <YoungPetModal isVisible={isYoungPetModalVisible} />
    </>
  );
};

export { NoPolicyPets };
